import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { defaultCardName } from '../utils';
import texts from '../texts';

/**
 * The bulk creator's confirmation dialogs, driven by the parent's modal state:
 * null | { type: 'leave' } | { type: 'remove', id }.
 */
const ConfirmModals = ({
  modal,
  cards,
  summary,
  onDismiss,
  onConfirmLeave,
  onConfirmRemove,
}) => {
  if (!modal) {
    return null;
  }

  if (modal.type === 'leave') {
    const uploading = summary.uploading > 0;
    return (
      <ConfirmDialog
        isOpen
        onConfirm={onConfirmLeave}
        onCancel={onDismiss}
        dialogTexts={{
          title: uploading ? texts.leaveTitleUploading : texts.leaveTitleUnsaved,
          content: uploading
            ? format(texts.leaveBodyUploading, { count: summary.uploading })
            : format(texts.leaveBodyUnsaved, { count: summary.unsaved }),
          confirm: texts.leaveAnyway,
          cancel: texts.stayOnPage,
        }}
      />
    );
  }

  // remove
  const index = cards.findIndex((item) => item.id === modal.id);
  const card = cards[index];
  const trimmedName = card ? card.name.trim() : '';
  const label = trimmedName ? `“${trimmedName}”` : defaultCardName(index + 1);
  return (
    <ConfirmDialog
      isOpen
      onConfirm={() => onConfirmRemove(modal.id)}
      onCancel={onDismiss}
      dialogTexts={{
        title: texts.removeTitle,
        content: format(texts.removeBody, { label }),
        confirm: texts.remove,
        cancel: texts.keepIt,
      }}
    />
  );
};

ConfirmModals.propTypes = {
  modal: PropTypes.shape({
    type: PropTypes.oneOf(['leave', 'remove']).isRequired,
    id: PropTypes.string,
  }),
  cards: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  })).isRequired,
  summary: PropTypes.shape({
    uploading: PropTypes.number,
    unsaved: PropTypes.number,
  }).isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirmLeave: PropTypes.func.isRequired,
  onConfirmRemove: PropTypes.func.isRequired,
};

ConfirmModals.defaultProps = {
  modal: null,
};

export default ConfirmModals;
